import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { Fattura } from '../../../models/fattura';

@Component({
    selector: '[fattura_entity_view]',
  templateUrl: 'fattura-entity-view.component.html',
})

export class FatturaEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element: Fattura;
}
